import { Box } from '@mui/material'
import { LocationModalityBadge } from 'src/components/MUIBased/AppointmentLocation'
import Markdown from 'src/components/MUIBased/Markdown'
import OfferingMarketingServiceLine from 'src/pages/MUIBased/Appointments/components/OfferingMarketingServiceLine'
import { AppointmentProfile } from 'src/types'

interface OfferingCardTopProps {
    offering: AppointmentProfile
}

const OfferingCardTop = ({ offering }: OfferingCardTopProps) => {
    return (
        <Box sx={{ p: 3 }}>
            <OfferingMarketingServiceLine offering={offering} />
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                    pr: '30px'
                }}
            >
                <Box sx={{ flexDirection: 'column', flex: 1 }}>
                    <Box
                        sx={{
                            fontWeight: 'bold',
                            fontSize: '18px',
                            lineHeight: '24px',
                            pb: 0.5
                        }}
                    >
                        {offering.label}
                    </Box>
                    <LocationModalityBadge
                        sx={{ paddingLeft: 0 }}
                        modalities={offering.locations}
                    />
                </Box>
                <img src={offering.imageUrl} alt={offering.name} />
            </Box>
            <Markdown
                text={offering.description as string}
                sx={{
                    pt: 2,
                    m: 0,
                    wordBreak: 'break-word',
                    color: 'text',
                    whiteSpace: 'pre-wrap',
                    display: '-webkit-box',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    fontSize: 15,
                    lineHeight: '21px'
                }}
            />
        </Box>
    )
}

export default OfferingCardTop
